<script>
    export let message = "Alerta";
    export let time = 3000;
    export let status = "success";

    export let visible = true;

    setTimeout(() => {
        visible = false;
    }, time);
</script>

{#if visible}
    <div class="alert alert-{status}">
        {message}
    </div>
{/if}
